"use client";

import { ThemeProvider } from "next-themes";
import { UserDataProvider } from "@/lib/UserDataContext";

export default function Providers({ children }: { children: React.ReactNode }) {
  return (
    <ThemeProvider
      attribute="class"
      defaultTheme="system"
      enableSystem
      disableTransitionOnChange
    >
      <UserDataProvider>{children}</UserDataProvider>
    </ThemeProvider>
  );
}
